import { ErrorMessageContents } from '../../../helpers/hub'
import { RestrictedTrades } from './types'

export const restrictedTradesFetch = () =>
  ({ type: 'restrictedtrades.fetch' } as const)
type RestrictedTradesFetchAction = ReturnType<typeof restrictedTradesFetch>

export const getRestrictedTradesSuccess = (
  restrictedTrades: RestrictedTrades[]
) =>
  ({
    type: 'restrictedtrades.addRestrictedTrades',
    payload: restrictedTrades
  } as const)
export type RestrictedTradesAddRestrictedTradesAction = ReturnType<
  typeof getRestrictedTradesSuccess
>

export const restrictedTradesFetchFail = (error: ErrorMessageContents) =>
  ({ type: 'restrictedtrades.fetchFail', payload: error, error: true } as const)
export type RestrictedTradesFetchFailAction = ReturnType<
  typeof restrictedTradesFetchFail
>

export const saveRestrictedTrades = (param: RestrictedTrades) =>
  ({ type: 'restrictedtrades.saveRestrictedTrades', payload: param } as const)
export type RestrictedTradesSaveAction = ReturnType<typeof saveRestrictedTrades>

export const saveRestrictedTradesSuccess = (
  restrictedTradesList: RestrictedTrades,
  transactionId?: number
) =>
  ({
    type: 'restrictedtrades.saveRestrictedTradesSuccess',
    payload: { restrictedTradesList, transactionId }
  } as const)
export type SaveRestrictedTradesSuccessAction = ReturnType<
  typeof saveRestrictedTradesSuccess
>

export const saveRestrictedTradesFailure = (error: ErrorMessageContents) =>
  ({
    type: 'restrictedtrades.saveRestrictedTradesFailure',
    payload: error,
    error: true
  } as const)
export type SaveRestrictedTradesFailureAction = ReturnType<
  typeof saveRestrictedTradesFailure
>

export const deleteRestrictedTrades = (param: RestrictedTrades[]) =>
  ({ type: 'restrictedtrades.deleteRestrictedTrades', payload: param } as const)
export type RestrictedTradesDeleteAction = ReturnType<
  typeof deleteRestrictedTrades
>

export const deleteRestrictedTradesSuccess = (
  restrictedTradesList: RestrictedTrades[],
  transactionId?: string
) =>
  ({
    type: 'restrictedtrades.deleteRestrictedTradesSuccess',
    payload: { restrictedTradesList, transactionId }
  } as const)
export type DeleteRestrictedTradesSuccessAction = ReturnType<
  typeof deleteRestrictedTradesSuccess
>

export const deleteRestrictedTradesFailure = (error: ErrorMessageContents) =>
  ({
    type: 'restrictedtrades.deleteRestrictedTradesFailure',
    payload: error,
    error: true
  } as const)
export type DeleteRestrictedTradesFailureAction = ReturnType<
  typeof deleteRestrictedTradesFailure
>

export const unsubscribeFromRestrictedTrades = () =>
  ({ type: 'restrictedtrades.fetchCancel' } as const)
export type RestrictedTradesFetchCancelAction = ReturnType<
  typeof unsubscribeFromRestrictedTrades
>

export type RestrictedTradesAction =
  | RestrictedTradesFetchAction
  | RestrictedTradesAddRestrictedTradesAction
  | RestrictedTradesFetchFailAction
  | RestrictedTradesSaveAction
  | SaveRestrictedTradesSuccessAction
  | SaveRestrictedTradesFailureAction
  | RestrictedTradesDeleteAction
  | DeleteRestrictedTradesSuccessAction
  | DeleteRestrictedTradesFailureAction
  | RestrictedTradesFetchCancelAction
